import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  standalone: false,
  selector: 'app-printable-layout',
  templateUrl: './printable-layout.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./printable-layout.component.css']
})
export class PrintableLayoutComponent { }
